import { Link } from "react-router-dom";

const Navbar = () => {
  return (
    <nav className="navbar navbar-expand-lg py-4 fixed-top" style={{background:"#101214"}}>
      <div className="container">
        <Link className="navbar-brand brand-name" to="/">Aura Financials</Link>
        <button 
          className="navbar-toggler" 
          type="button" 
          data-bs-toggle="collapse" 
          data-bs-target="#navbarSupportedContent" 
          aria-controls="navbarSupportedContent" 
          aria-expanded="false" 
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav mx-auto">
            <li className="nav-item">
              <Link className="nav-link px-3 active" to="/">Home</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link px-3" to="/about">About</Link>
            </li>    
            <li className="nav-item">
              <Link className="nav-link px-3" to="/contact">Contact</Link>
            </li>  
            <li className="nav-item">
              <Link className="nav-link px-3" to="/services">Services</Link>
            </li>  
          </ul>
          <div className="d-flex">
          <Link to="/blog"><button className="btn btn-outline-light rounded-pill px-4 ms-2">Blogs</button></Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
